var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04GraphNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360.6 245.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-4 {\n        mask: url(#mask-5);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill: #042b62;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-16 {\n        mask: url(#mask-1);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35 {\n        fill: none;\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-38 {\n        mask: url(#mask-10);\n      }\n\n      .cls-39 {\n        mask: url(#mask-6);\n      }\n\n      .cls-40 {\n        mask: url(#mask-7);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-42 {\n        mask: url(#mask);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-23 {\n        stroke: url(#linear-gradient-13);\n        stroke-miterlimit: 10;\n      }\n\n      .cls-48 {\n        mask: url(#mask-8);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-49 {\n        mask: url(#mask-2);\n      }\n\n      .cls-50 {\n        mask: url(#mask-9);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-69 {\n        mask: url(#mask-4);\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-75 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-76 {\n        opacity: .5;\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-78 {\n        mask: url(#mask-3);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 0.4,
    y: 0.3,
    width: 359.5,
    height: 244.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5,
    y1: -55.5,
    x2: 111.7,
    y2: 51.3,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -2,
    y: -2,
    width: 80,
    height: 297.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "4.3 242.2 78 165.3 78 295.6 4.4 295.6 4.3 242.2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5,
    y1: -55.5,
    x2: 111.7,
    y2: 51.3,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0f1ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 68.4,
    y1: -16.7,
    x2: 130.7,
    y2: 45.6,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: -2,
    y: -2,
    width: 129.5,
    height: 297.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "77.8 165.3 77.8 165.3 127.5 183.3 127.5 295.6 78 295.6 77.8 165.3"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 68.4,
    y1: -16.7,
    x2: 130.7,
    y2: 45.6,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0f1ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 130.2,
    y1: -7,
    x2: 197.9,
    y2: 60.7,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: -2,
    y: -2,
    width: 166,
    height: 297.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "127.5 183.3 127.5 183.3 164 151.9 164 295.6 127.5 295.6 127.5 183.3"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 130.2,
    y1: -7,
    x2: 197.9,
    y2: 60.7,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0f1ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 171.6,
    y1: 6.6,
    x2: 248,
    y2: 83,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: -2,
    y: -2,
    width: 216.5,
    height: 297.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "164 151.9 164 151.9 214.5 147.4 214.5 295.6 164 295.6 164 151.9"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 171.6,
    y1: 6.6,
    x2: 248,
    y2: 83,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0f1ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 202.1,
    y1: 2.2,
    x2: 319.6,
    y2: 119.7,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: -2,
    y: -2,
    width: 281.6,
    height: 297.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "279.6 41.1 279.6 295.6 214.5 295.6 214.5 147.4 214.5 147.4 279.6 41.1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 202.1,
    y1: 2.2,
    x2: 319.6,
    y2: 119.7,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0f1ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 285.5,
    y1: 44.9,
    x2: 422.7,
    y2: 182.1,
    gradientTransform: "translate(0 248) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: -2,
    y: -2,
    width: 362.9,
    height: 297.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "279.6 295.6 279.6 41.1 279.6 41.1 360.9 5.8 360.9 295.6 279.6 295.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 279.6,
    y1: 150.7,
    x2: 360.9,
    y2: 150.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183c6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 0.4,
    y: 0.3,
    width: 359.5,
    height: 244.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 8.7,
    y1: 114.6,
    x2: 353.7,
    y2: 136.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042b62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042b62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 485.8,
    y1: -336.2,
    x2: 493.4,
    y2: -336.2,
    gradientTransform: "translate(-390.1 -200.6) rotate(3.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: -2,
    y: -2,
    width: 83.6,
    height: 171.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M81.6,165.5c0,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4s1.9-3.7,4-3.6c2.1.1,3.7,1.9,3.6,4Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 536.6,
    y1: -351.1,
    x2: 544.2,
    y2: -351.1,
    gradientTransform: "translate(-390.1 -200.6) rotate(3.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: -2,
    y: -2,
    width: 133.3,
    height: 189.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.3,183.5c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4s1.9-3.7,4-3.6c2.2.1,3.8,1.9,3.6,4Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 571.1,
    y1: -317.5,
    x2: 578.7,
    y2: -317.5,
    gradientTransform: "translate(-390.1 -200.6) rotate(3.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: -2,
    y: -2,
    width: 169.8,
    height: 157.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M167.8,152.1c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4,.1-2.1,1.9-3.7,4-3.6s3.7,1.9,3.6,4Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 621.2,
    y1: -309.8,
    x2: 628.8,
    y2: -309.8,
    gradientTransform: "translate(-390.1 -200.6) rotate(3.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: -2,
    y: -2,
    width: 220.3,
    height: 153.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M218.3,147.6c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4,.1-2.1,1.9-3.7,4-3.6s3.7,1.9,3.6,4Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1 1 2 1 1 2 1 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 679.5,
    y1: -199.7,
    x2: 687.2,
    y2: -199.7,
    gradientTransform: "translate(-390.1 -200.6) rotate(3.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: -2,
    y: -2,
    width: 285.4,
    height: 46.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M283.4,41.3c-.1,2.1-1.9,3.7-4,3.6-2.1,0-3.7-1.9-3.6-4s1.9-3.7,4-3.6,3.7,1.9,3.6,4Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 0.4,
    y: 0.3,
    width: 359.5,
    height: 244.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1.7,238.5c-3.6,0-6.4,2.9-6.4,6.4s2.9,6.4,6.4,6.5c3.6,0,6.4-2.9,6.4-6.4s-2.9-6.4-6.4-6.5ZM6.1,247c0,0,0,.2-.2.3-.8,1.5-2.4,2.5-4.3,2.5-2.7,0-4.9-2.2-4.9-4.8s.3-1.9.8-2.7c0,0,0-.2.2-.3h0C-1.3,240.8,0,240.2,1.5,240.2s2.6.5,3.4,1.4q0,.1.2.2s0,.1,0,.2c.2.2.3.4.4.6h0c0,.1,0,.2,0,.2,0,.1,0,.1,0,.2h0c.3.7.4,1.4.4,2.1.3.6.2,1.3,0,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M-4.4,245.1c0-3.3,2.7-6,6-6s6,2.7,6,6-2.7,6-6,6-6-2.7-6-6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M77.8,158.9c-3.6,0-6.4,2.9-6.4,6.4s2.9,6.5,6.4,6.5,6.4-2.9,6.4-6.4c0-3.6-2.8-6.5-6.4-6.5ZM82.2,167.3c0,.1,0,.2-.2.3-.8,1.5-2.4,2.5-4.3,2.5-2.7,0-4.9-2.2-4.9-4.8s.3-1.9.8-2.7c0,0,0-.2.2-.3h0c.9-1.2,2.2-1.8,3.7-1.8s2.6.5,3.4,1.4l.2.2s0,.1,0,.2c.2.2.3.4.4.6h0c0,0,0,.2,0,.2,0,.1,0,.1,0,.2h0c.3.7.4,1.4.4,2.1.4.6.2,1.3,0,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M71.8,165.4c0-3.3,2.7-6,6-6s6,2.7,6,6-2.7,6-6,6-6-2.7-6-6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M127.5,176.8c-3.6,0-6.4,2.9-6.4,6.4s2.9,6.5,6.4,6.5,6.4-2.9,6.4-6.4-2.8-6.5-6.4-6.5ZM131.9,185.2c0,0-.1.2-.2.3-.8,1.5-2.4,2.5-4.3,2.5-2.7,0-4.9-2.2-4.9-4.8s.3-1.9.8-2.7c0,0,0-.2.2-.3h0c.9-1.2,2.2-1.8,3.7-1.8s2.6.5,3.4,1.4q.1.1.2.2c0,0,.1,0,.1.2.2.2.3.4.4.6h0c0,.1,0,.2.1.2,0,0,.1,0,.1.2h0c.3.7.4,1.4.4,2.1.3.7.2,1.3,0,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M121.5,183.3c0-3.3,2.7-6,6-6s6,2.7,6,6-2.7,6-6,6c-3.4.1-6.1-2.6-6-6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M164,145.5c-3.6,0-6.4,2.9-6.4,6.4s2.9,6.5,6.4,6.5,6.4-2.9,6.4-6.4-2.9-6.5-6.4-6.5ZM168.4,153.9c0,0-.1.2-.2.3-.8,1.5-2.4,2.5-4.3,2.5-2.7,0-4.9-2.2-4.9-4.8s.3-1.9.8-2.7c.1-.1.1-.2.2-.3h.1c.9-1.2,2.2-1.8,3.7-1.8s2.6.5,3.4,1.4q.1,0,.2.2s.1.1.1.2c.2.2.3.4.4.6h0c0,0,0,.2.1.2,0,0,.1,0,.1.2h0c.3.7.4,1.4.4,2.1.3.6.2,1.3-.1,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M157.9,152c0-3.3,2.7-6,6-6s6,2.7,6,6-2.7,6-6,6-6-2.7-6-6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M214.5,140.9c-3.6,0-6.4,2.9-6.4,6.4s2.9,6.5,6.4,6.5,6.4-2.9,6.4-6.4-2.8-6.5-6.4-6.5ZM218.9,149.4c0,0-.1.2-.2.3-.8,1.5-2.4,2.5-4.3,2.5-2.7,0-4.9-2.2-4.9-4.8s.3-1.9.8-2.7c.1-.1.1-.2.2-.3h.1c.9-1.2,2.2-1.8,3.7-1.8s2.6.5,3.4,1.4q.1,0,.2.2s.1.1.1.2c.2.2.3.4.4.6h0c0,0,0,.2.1.2,0,0,.1,0,.1.2h0c.3.7.4,1.4.4,2.1.3.6.2,1.3-.1,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M208.5,147.5c0-3.3,2.7-6,6-6s6,2.7,6,6-2.7,6-6,6-6.1-2.7-6-6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M279.5,34.6c-3.6,0-6.4,2.9-6.4,6.4s2.9,6.5,6.4,6.5,6.4-2.9,6.4-6.4c.1-3.6-2.8-6.5-6.4-6.5ZM284,43c0,0-.1.2-.2.3-.8,1.5-2.4,2.5-4.3,2.5-2.7,0-4.9-2.2-4.9-4.8s.3-1.9.8-2.7c.1-.1.1-.2.2-.3h.1c.9-1.2,2.2-1.8,3.7-1.8s2.6.5,3.4,1.4q.1,0,.2.2s.1,0,.1.2c.2.2.3.4.4.6h0c0,0,0,.2.1.2,0,0,.1,0,.1.2h0c.3.7.4,1.4.4,2.1.3.7,0,1.3-.1,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M273.5,41.1c0-3.3,2.7-6,6-6s6,2.7,6,6-2.7,6-6,6c-3.3,0-6-2.6-6-6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M360.9-.7c-3.6,0-6.4,2.9-6.4,6.4s2.9,6.5,6.4,6.5,6.4-2.9,6.4-6.4-2.8-6.5-6.4-6.5ZM365.3,7.8c0,0-.1.2-.2.3-.8,1.5-2.4,2.5-4.3,2.5-2.7,0-4.9-2.2-4.9-4.8s.3-1.9.8-2.7c.1,0,.1-.2.2-.3h.1c.9-1.2,2.2-1.8,3.7-1.8s2.6.5,3.4,1.4l.2.2s.1,0,.1.2c.2.2.3.4.4.6h0c0,0,0,.2.1.2,0,0,.1,0,.1.2h0c.3.7.4,1.4.4,2.1.3.6.2,1.3-.1,1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M354.9,5.9c0-3.3,2.7-6,6-6s6,2.7,6,6-2.7,6-6,6-6.1-2.7-6-6Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "4.3 242.2 78 165.3 78 295.6 4.4 295.6 4.3 242.2"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "4.3 242.2 78 165.3 78 295.6 4.4 295.6 4.3 242.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-2",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "77.8 165.3 77.8 165.3 127.5 183.3 127.5 295.6 78 295.6 77.8 165.3"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "77.8 165.3 77.8 165.3 127.5 183.3 127.5 295.6 78 295.6 77.8 165.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-3",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "127.5 183.3 127.5 183.3 164 151.9 164 295.6 127.5 295.6 127.5 183.3"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "127.5 183.3 127.5 183.3 164 151.9 164 295.6 127.5 295.6 127.5 183.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-4",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "164 151.9 164 151.9 214.5 147.4 214.5 295.6 164 295.6 164 151.9"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "164 151.9 164 151.9 214.5 147.4 214.5 295.6 164 295.6 164 151.9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-5",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "279.6 41.1 279.6 295.6 214.5 295.6 214.5 147.4 214.5 147.4 279.6 41.1"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "279.6 41.1 279.6 295.6 214.5 295.6 214.5 147.4 214.5 147.4 279.6 41.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-6",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "279.6 295.6 279.6 41.1 279.6 41.1 360.9 5.8 360.9 295.6 279.6 295.6"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "279.6 295.6 279.6 41.1 279.6 41.1 360.9 5.8 360.9 295.6 279.6 295.6"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "2.1 245.4 1.3 244.6 77.8 164.7 127.2 182.4 164.4 151.3 214.1 146.7 279.4 40.7 360.7 5.3 361.1 6.3 280.1 41.6 214.8 147.7 164.8 152.4 127.4 183.7 78.1 166 2.1 245.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "SVGID-7",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.6,165.5c0,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4s1.9-3.7,4-3.6c2.1.1,3.7,1.9,3.6,4Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.6,165.5c0,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4s1.9-3.7,4-3.6c2.1.1,3.7,1.9,3.6,4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-8",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.3,183.5c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4s1.9-3.7,4-3.6c2.2.1,3.8,1.9,3.6,4Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.3,183.5c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4s1.9-3.7,4-3.6c2.2.1,3.8,1.9,3.6,4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-9",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.8,152.1c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4,.1-2.1,1.9-3.7,4-3.6s3.7,1.9,3.6,4Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.8,152.1c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4,.1-2.1,1.9-3.7,4-3.6s3.7,1.9,3.6,4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-10",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218.3,147.6c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4,.1-2.1,1.9-3.7,4-3.6s3.7,1.9,3.6,4Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218.3,147.6c-.1,2.1-1.9,3.7-4,3.6-2.1-.1-3.7-1.9-3.6-4,.1-2.1,1.9-3.7,4-3.6s3.7,1.9,3.6,4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGID-11",
    "data-name": "SVGID"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1 1 2 1 1 2 1 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-1 -1 -2 -1 -1 -2 -1 -1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M283.4,41.3c-.1,2.1-1.9,3.7-4,3.6-2.1,0-3.7-1.9-3.6-4s1.9-3.7,4-3.6,3.7,1.9,3.6,4Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M283.4,41.3c-.1,2.1-1.9,3.7-4,3.6-2.1,0-3.7-1.9-3.6-4s1.9-3.7,4-3.6,3.7,1.9,3.6,4Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04GraphNew);
export default __webpack_public_path__ + "static/media/04_graph_new.868e0e2f8250881fc6ef2708232432e1.svg";
export { ForwardRef as ReactComponent };